<template>
  <div class="attempt-picker">
    <button
      type="button"
      class="attempt-chip"
      :class="{ selected: active && !selected }"
      @click="$emit('select', null)"
    >
      All attempts
    </button>
    <button
      v-for="scan in scans"
      :key="scan.idscanImageId"
      type="button"
      class="attempt-chip"
      :class="{ selected: active && selected === scan.idscanImageId }"
      :title="caption(scan)"
      @click="choose(scan)"
    >
      {{ sideLabel(scan) }} {{ scan.attempt }} ·
      <span
        :class="isPassedResult(scan.result) ? 'text-success' : 'text-danger'"
      >
        {{ scan.result }}
      </span>
    </button>
  </div>
</template>

<script>
import {
  attemptCaption,
  isPassedResult,
  sideLabel,
} from "@/utils/idScanAttempts";

// The attempts of one journey as chips (ENG-2625). Emits the chosen attempt's IDScan image id,
// or null for every attempt; choosing the selected attempt again goes back to every attempt.
export default {
  name: "IdScanAttemptPicker",
  props: {
    scans: { type: Array, required: true },
    selected: { type: String, default: null },
    // Whether this picker's journey is the one being shown.
    active: { type: Boolean, default: true },
  },
  methods: {
    sideLabel,
    isPassedResult,
    caption: attemptCaption,
    choose(scan) {
      const same = this.active && this.selected === scan.idscanImageId;
      this.$emit("select", same ? null : scan.idscanImageId);
    },
  },
};
</script>

<style scoped>
.attempt-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.attempt-chip {
  padding: 2px 10px;
  font-size: 12px;
  line-height: 1.6;
  border: 1px solid #ced4da;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
}

.attempt-chip.selected {
  border-color: #17a2b8;
  box-shadow: 0 0 0 1px #17a2b8;
  font-weight: 600;
}
</style>
